import { Link } from "react-router-dom"

const DoctorCard = ({ doctor }) => {
const doctorSlug = doctor.slug;
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden">
      <div className="aspect-[6/5] sm:aspect-[5/5] relative bg-gray-100">
        <img
          src={doctor.imageUrl || "/placeholder.svg?height=400&width=300"}
          alt={doctor.name}
          className="object-cover w-full h-full"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-1">{doctor.name}</h3>
        <p className="text-teal-800 font-medium mb-1">{doctor.specialty}</p>
        <p className="text-gray-700 font-medium mb-1">
            {doctor.designation}
          </p>

          <p className="text-gray-700 text-sm mb-1">
            {doctor.qualification}
          </p>

          <p className="text-gray-700 text-sm mb-1">
            {doctor.experience}
          </p>
        <div className="flex flex-col sm:flex-row gap-2">
          {/* <Link className="flex-1 w-full bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors text-center" to={`/doctors/${doctorSlug}`}>
              View Profile       
          </Link> */}
          {/* <Link to="/book-appointment" className="flex-1">
            <button className="w-full bg-gray-100 text-gray-800 px-4 py-2 rounded-full text-sm font-medium hover:bg-gray-200 transition-colors">
              Book Appointment
            </button>
          </Link> */}
        </div>
      </div>
    </div>
  )
}

export default DoctorCard
